import { GetStoreManagerHierarchyRequest } from '@app/infrastructure/api/models';

export class SetStoreManagerListConfig {
  static readonly type = '[Store Manager] Set List Config';
  constructor(public config: GetStoreManagerHierarchyRequest) {}
}

export class SaveStoreManagerViewState {
  static readonly type = '[Store Manager] Save View State';
  constructor(
    public expandedLocationId: string | undefined,
    public scrollPosition: number,
  ) {}
}

export class ResetStoreManagerViewState {
  static readonly type = '[Store Manager] Reset View State';
}
